module.exports = __webpack_public_path__ + "static/media/debooster.e94bc44a.svg";